/**
 * @summary     ui.logic
 * @description Logical computator for UI
 * @version     1.1
	> 1.0 Initial version
		- 03/17/2016 SG WD-83
	> 1.1 Added indexOf to commands
		- 03/28/2016 SG WD-86
	> 1.2 Updated applyVisibility() to support array-type values from app.events.
		- 01/08/2018 KK HSC-162
 * @file        app.ui.logic.js
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** Examples:
 ** NOTE:
 ** TODO:
*/

app.ui.addFeature(
	"logic",
	function(){

		var self = this;

		/*
			Name: applyCommand
			Use: PRIVATE.applyCommand()
			Args: logic Object - The the logic rule with trigger value and operator
					val Any - The value used in the comparison
			Description: Returns the results of the value comparison based upon the logical operator
		*/
		function applyCommand(logic,val){
			try {

				const valuesAreNumbers = (...args)=> args.every(value=>!Number.isNaN(Number(value)));

				return {
					"===" : function(){
						return val === logic.value;
					},
					"!==" : function(){
						return val !== logic.value;
					},
					">" : function(){
						if(valuesAreNumbers(val,logic.value)) return Number(val) > Number(logic.value);
						return val > logic.value;
					},
					"<" : function(){
						if(valuesAreNumbers(val,logic.value)) return Number(val) < Number(logic.value);
						return val < logic.value;
					},
					">=" : function(){
						if(valuesAreNumbers(val,logic.value)) return Number(val) >= Number(logic.value);
						return val >= logic.value;
					},
					"<=" : function(){
						if(valuesAreNumbers(val,logic.value)) return Number(val) <= Number(logic.value);
						return val <= logic.value;
					},
					"indexOf" : function(){
						try {
							const strVal = (typeof val === 'string') ? val : JSON.stringify(val);
							return JSON.parse(strVal).indexOf(logic.value) !== -1;
						}
						catch(e){
							//the justification for this check, is that the val is given by $().text() which does not give values in a comma delimited string, but a smashed string
							if(val.indexOf(",") > -1) {
								return val.split(",").indexOf(logic.value) !== -1;
							}
							else {
								return val.indexOf(logic.value) !== -1;
							}
						}
					},
					"notIndexOf" : function(){
						try {
							return JSON.parse(val).indexOf(logic.value) === -1;
						}
						catch(e){
							//the justification for this check, is that the val is given by $().text() which does not give values in a comma delimited string, but a smashed string
							if(val.indexOf(",") > -1) {
								return val.split(",").indexOf(logic.value) === -1;
							}
							else {
								return val.indexOf(logic.value) === -1;
							}
						}
					},
					"either" : function() {
						try {
							return JSON.parse(logic.value).indexOf(val) !== -1;
						}
						catch(e){
							return logic.value.split(",").indexOf(val) !== -1;
						}
					},
					"neither" : function() {
						try {
							return JSON.parse(logic.value).indexOf(val) === -1;
						}
						catch(e){
							return logic.value.split(",").indexOf(val) === -1;
						}
					}
				}[logic.valueAction]();
			}
			catch(e){
				// TODO: Proper error handling
				return false;
			}
		}

		/*
			Name: applyFilter
			Use: PRIVATE.applyFilter()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
					logic Object - The properties defining this logical rule
			Description: Applies filter by logic
		*/
		function applyFilter(field,logic, form, metaMap, vueData, fieldEventPrepend){
			if(!field.requestArgs){
				field.requestArgs = {};
			}

			field.requestArgs.filterBySrc = logic.src;
			field.requestArgs.filterByCol = logic.col;

			if(logic.filterType === "field"){
				field.requestArgs.filterByVal = field.dataInstance[logic.field];
				/*
					NOTE:
						Subscribe to value changes on the source field of the filter value and update the options
				*/
				app.events.on(
					fieldEventPrepend + logic.field,
					function(obj){
						field.requestArgs.filterByVal = obj.newValue;
						$("#" + field.args.properties.id).html("<option>Loading...</option>");
						field.setOptions();
					}
				);
			}
			else {
				field.requestArgs.filterByVal = logic.value;
			}

			return self;
		}

		self.constrainByOtherField = function(field,logic, form, metaMap, vueData, obj){
			var formConfigs = {meta: {form: form}},
				idx = metaMap[field.args.properties.id],
				meta = formConfigs.meta.form[idx],
				failedMeta,
				failedRule,
				conditionFailed = false;

				logic.rules.forEach(function(rule) {
					var sourceField = $("#" + rule.field),
						val = obj.newValue;

						/*
							NOTE:
								Now verify the logical condition is true and handle thusly
						*/
						if(sourceField.is("select")){
							const selected = sourceField.find("option:selected");
							val = selected.data("displaytext") ?? selected.text();
						}


						if(field.args.type === "date") {
							rule.value = new Date(sourceField.val()).getTime();
							val = new Date(val).getTime();
						}
						else {
							rule.value = sourceField.val();
						}

						if(obj.newValue !== "" && sourceField.val() !== "" && !applyCommand(rule,val)){
							if(rule.operator === "AND") {
								failedMeta = formConfigs.meta.form[metaMap[rule.field]];
								failedRule = rule;
								conditionFailed = true;
							}
						}
						else if(rule.operator === "OR") {
							conditionFailed = false;
						}


				});

				if(conditionFailed && obj.type !== "ON_INIT") {
					alert(meta.properties.label + " must be " + failedRule.valueAction + " than " + failedMeta.properties.label );
					document.getElementById(meta.properties.id).focus();
				}
				return !conditionFailed;
		}


		function constrainByOtherFieldSetup(field, logic, form, metaMap, vueData, fieldEventPrepend){
			//logic.rules.forEach(function(rule) {
				/*
					NOTE:
						Subscribe to value changes on the source field and make it required if condition is met
				*/

				app.events.on(
					fieldEventPrepend + field.field.id,//rule.field,
					function(obj){
							self.constrainByOtherField(field, logic, form, metaMap, vueData, obj);
						});

				//	});

		};

		/*
			Name: applyRequire
			Use: PRIVATE.applyRequire()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
					logic Object - The properties defining this logical rule
			Description: Applies required logic
		*/
		function applyRequire(field,logic, form, metaMap, vueData, fieldEventPrepend){
			if(logic.rules) {
				logic.rules.forEach(function(rule) {
					/*
						NOTE:
							Subscribe to value changes on the source field and make it required if condition is met
					*/

					app.events.on(
						fieldEventPrepend + rule.field,
						function(obj){
							var formConfigs = {meta: {form: form}},
								idx = metaMap[field.args.properties.id],
                			meta = formConfigs.meta.form[idx],
								conditionFailed = false;

							/* NOTE:
								Revert the value to the default and update CSS accordingly
							*/
              //meta.required = metaCopy.required;
							$("#label-" + field.args.properties.id)[meta.required?"addClass":"removeClass"]("required");



							logic.rules.forEach(function(rule) {
								var sourceField = $("#" + rule.field),
									val = sourceField.val();//obj.newValue;

									/*
										NOTE:
											Now verify the logical condition is true and handle thusly
									*/
									if(sourceField.is("select")){
										const selected = sourceField.find("option:selected");
                                        val = selected.data("displaytext") ?? selected.text();
									}

									if(!applyCommand(rule,val)){
										if(rule.operator === "AND") {
											conditionFailed = true;
										}
									}
									else if(rule.operator === "OR") {
										conditionFailed = false;
									}


							});

							if(!conditionFailed) {
								meta.required = true;
								if(logic.idOverride && logic.idOverride !== "") {
									if(meta.type === "address-control") {
										document.getElementById(logic.idOverride).parentNode.getElementsByClassName("input-group-addon")[0].classList.add("required");
									}
									else {
										$("#label-" + logic.idOverride).addClass("required");
									}
								}
								else {
										$("#label-" + field.args.properties.id).addClass("required");
								}
							}
							else {
								if(logic.idOverride && logic.idOverride !== "") {
									if(meta.type === "address-control") {
										document.getElementById(logic.idOverride).parentNode.getElementsByClassName("input-group-addon")[0].classList.remove("required");
									}
									else {
										$("#label-" + logic.idOverride).removeClass("required");
									}
								}
								else {
										$("#label-" + field.args.properties.id).removeClass("required");
								}
								meta.required = false;
							}

						}
					);
				});
			}
			
			if(logic.filterType === "field" && logic.field){
				/*
					NOTE:
						Subscribe to value changes on the source field and make it required if condition is met
				*/
				app.events.on(
					fieldEventPrepend + logic.field,
					function(obj){
						var formConfigs = {meta: {form: form}},
							idx = metaMap[field.args.properties.id],
							meta = formConfigs.meta.form[idx],
							sourceField = $("#" + logic.field),
							val = obj.newValue;

						/* NOTE:
							Revert the value to the default and update CSS accordingly
						*/
            //meta.required = metaCopy.required;
						$("#label-" + field.args.properties.id)[meta.required?"addClass":"removeClass"]("required");

						/*
							NOTE:
								Drop downs may have different display views that actual values, use the display view
						*/
						if(sourceField.is("select")){
							const selected = sourceField.find("option:selected");
							val = selected.data("displaytext") ?? selected.text();
						}

						/*
							NOTE:
								Now verify the logical condition is true and handle thusly
						*/
						if(applyCommand(logic,val)){
							meta.required = true;

							if(logic.idOverride && logic.idOverride !== "") {
								if(meta.type === "address-control") {
									document.getElementById(logic.idOverride).parentNode.getElementsByClassName("input-group-addon")[0].classList.add("required");
								}
								else {
									$("#label-" + logic.idOverride).addClass("required").css('color', 'rgb(175, 0, 0)');
								}
							}
							else {
								$('label[for=' + field.args.properties.id + ']').addClass("required").css('color', 'rgb(175, 0, 0)');
							}
						}
						else {
							if(logic.idOverride && logic.idOverride !== "") {
								if(meta.type === "address-control") {
									document.getElementById(logic.idOverride).parentNode.getElementsByClassName("input-group-addon")[0].classList.remove("required");
								}
								else {
									$("#label-" + logic.idOverride).removeClass("required");
								}
							}
							else {
								$('label[for=' + field.args.properties.id + ']').removeClass("required").css('color', 'rgb(0, 0, 0)');
							}
							meta.required = false;
						}
					}
				);
			}

			return self;
		}

		/*
			Name: applyVisibility
			Use: PRIVATE.applyVisibility()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
					logic Object - The properties defining this logical rule
			Description: Applies visibility logic
		*/
		function applyVisibility(field,logic, form, metaMap, vueData, fieldEventPrepend){
			if(logic.filterType === "field" && logic.field){
				/*
					NOTE:
						Subscribe to value changes on the source field and make it required if condition is met
				*/
				app.events.on(
					fieldEventPrepend + logic.field,
					function(obj){
						var sourceField = $("#" + logic.field),
							val = "",
							display = {
								show : "block",
								hide : "none"
							}[logic.type],
							defaultDisplay = logic.display?logic.display:null,
							$lbl = $("#label-" + field.properties.id),
							$fld = $("#container-" + field.properties.id),
							$container = $("#" + field.properties.id).closest(".w-col");
              if($container.length === 0) {
                $container = $("#" + field.properties.id + "0").closest(".w-col")
              }
						/*
							NOTE:
								Drop downs may have different display views that actual values, use the display view
						*/
						if(sourceField.is("select")){
							const selected = sourceField.find("option:selected");
							val = selected.data("displaytext") ?? selected.text();
						}
						else if(!sourceField.length) {
							// see if its a checkbox field by looking for the checkbox inputs
							var checkboxFields = $(`input[data-path='fieldValues.${logic.field}']`);
							if (checkboxFields.length) {
								val = [];
								for (let checkBox of checkboxFields) {
									if (checkBox.checked) {
										val.push(checkBox.value);
									}
								}
							}
						}
						/*
							NOTE:
								Violation Checklists may emit events that are not pertinent to show/hide logic but are used elsewhere for keeping track of observation data.
								The value that we want to use for show/hide logic for Violation Checklists instead is the Checklist's inspectionTypeID.
						*/
						else if(logic.field === "inspectionTypeID" && obj.type !== "ON_INIT") {
							val = $("#" + logic.field).val();
						}
						else {
							val = obj.newValue;
						}

						var idOverrideEl;

						if(logic.idOverride && logic.idOverride !== "") {
							idOverrideEl = document.getElementById(logic.idOverride);
						}


						/*
							NOTE:
								Now process the show/hide logic for each value
						*/
						if(logic.target === "group") {
							var $groupId = $("#" + field.properties.group.replace(/\W/g,''));

							if(applyCommand(logic,val)){
								$groupId.css("display",display);
							}
							else if(defaultDisplay !== null){
								$groupId.css("display",defaultDisplay);
							}
						}
						else if(idOverrideEl) {
							if(applyCommand(logic,val)){
								$("#label-"+logic.idOverride).css("display",display);
								$(idOverrideEl).css("display",display);
							}
							else if(defaultDisplay !== null){
								$("#label-"+logic.idOverride).css("display",defaultDisplay);
								$(idOverrideEl).css("display",display);
							}
						}
						else {
							if(applyCommand(logic,val)){
								$lbl.css("display",display);
								$fld.css("display",display);
								$container.css("display",display);
							}
							else if(defaultDisplay !== null){
								$lbl.css("display",defaultDisplay);
								$fld.css("display",defaultDisplay);
								$container.css("display",defaultDisplay);
							}
						}
					}
				);
			}

			return self;
		}

		/*
			Name: applyValueChange
			Use: PRIVATE.applyValueChange()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
					logic Object - The properties defining this logical rule
			Description: Applies Value Change logic
		*/
		function applyValueChange(field, logic, form, metaMap, vueData, fieldEventPrepend){
			if(logic.filterType === "field" && logic.field) {
				app.events.on(fieldEventPrepend + logic.field, function(event) {
					// Only execute Value Change logic after the UI has been initialized to avoid values changing on-load.
					if(event.type !== "ON_INIT") {
						var $targetField = $("#" + field.properties.id);
						var newValue = event.newValue;
						/*
							NOTE:
								Use the fieldValues of the subform if it exists, other was use the fieldValues of the main form for the form data
								- ch 03/30/2022
						*/
						var lclFormObj = (vueData.subforms && vueData.subforms[field.properties.id]) ? vueData.subforms[field.properties.id].fieldValues : vueData.fieldValues;

						/*
							NOTE:
							I don't like this code, but I put it in to fix bug for https://healthspace.atlassian.net/browse/HSC-799
							For some reason logic.targetValue was a number not a string. I do not know why, but this will fix the bug for now.
							*/
							if(typeof logic.targetValue !== "string") {
								logic.targetValue = logic.targetValue.toString();
							}

						if(applyCommand(logic, newValue)) {
							$targetField.val(
								logic.targetValue.compile(
									lclFormObj
								)
							);
							/*
								NOTE:
									Try to account for the lack of access to the VueJS object in various formats, let's try to transmit the proper DOM event
									- sg 06//25/2019
							*/
							try {
								$targetField[0].dispatchEvent(
									new Event('input')
								);
								$targetField[0].dispatchEvent(
									new Event('change')
								);
							}
							catch(e){}
						}
						/*
							NOTE:
								Quick application of existing UI elements and configurations that are available in Form Builder to allow for dynamic calculations of dates
								such as Field B = Field A + 30 days.  This is expressed in the targetValue parameter as '+|-nD' aka '+30d' or '-1y'.  We only support basic add/subtract for now
								- sg 03/25/2019
						*/
						else if(!logic.value && !logic.valueAction && field.args.type === 'date') {
							var originalDate = moment(newValue);

							if(originalDate.isValid()){
								var action = logic.targetValue.replace(/[\s?\d\w]/ig,'') === '+'?'add':'subtract',
									number = logic.targetValue.replace(/[\+|\-\s?]/ig,'').replace(/\D/ig,''),
									unit = logic.targetValue.replace(/[\+|\-\s?]/ig,'').replace(/\d/ig,'');

								// app.config.system.dateFormat ||
								$targetField.val(
									originalDate[action](number, unit).format(
										('mm/dd/yyyy').toUpperCase()
									)
								);

								/*
									NOTE:
										Try to account for the lack of access to the VueJS object in various formats, let's try to transmit the proper DOM event
										- sg 06//25/2019
								*/
								try {
									$targetField[0].dispatchEvent(
										new Event('blur')
									);
								}
								catch(e){}
							}
						}
					}
				});
			}

			return self;
		}

		/*
			Name: applyEntryValidation
			Use: PRIVATE.applyEntryValidation()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
					logic Object - The properties defining this logical rule
			Description: Applies Entry Validation logic
		*/
		function applyPopulateOtherFields(field, logic, form, metaMap, vueData, fieldEventPrepend){
			if(logic.type === 'populateOtherFields' && logic.fields) {
				app.events.on(
					fieldEventPrepend + field.properties.id,
					function(event) {
						// Only execute Value Change logic after the UI has been initialized to avoid values changing on-load.
						if(event.type !== "ON_INIT") {
							try {
								var $field = $('[data-instanceid="{properties.data-instanceid}"]'.compile(field)),
									optionsData = JSON.parse(
										$field.attr('data-optionsdata')
									),
									optionsMap = JSON.parse(
										$field.attr('data-optionsmap')
									),
									optionsRow = optionsData[optionsMap[$field.val()]];

								if(optionsRow){
									var targetFieldId, $targetField, rowCol;

									for(rowCol in optionsRow){
										optionsRow[rowCol] = optionsRow[rowCol].toString().compile(
											{
												now: moment().format('MM/DD/YYYY'),
												session: app.config.session,
												userID: app.config.session.userID,
												parentRecord : app.localCache.get('parentRecord','session')
											}
										);
									}

									for(targetFieldId in logic.fields){
										$targetField = $('#' + targetFieldId);

										$targetField.val(
											logic.fields[targetFieldId].compile(
												{
													optionsData : optionsRow,
													value : $field.val(),
													value : $('[data-instanceid="{properties.data-instanceid}"] option:selected'.compile(field)).text()
												}
											)
										);

										try {
											$targetField[0].dispatchEvent(
												new Event('blur')
											);
										}
										catch(e2){}
									}
								}
							}
							catch(e){
								console.log('e',e,field,$field);
							}
						}
					}
				);
			}

			return self;
		}

		/*
			Name: applyEntryValidation
			Use: PRIVATE.applyEntryValidation()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
					logic Object - The properties defining this logical rule
			Description: Applies Entry Validation logic
		*/
		function applyEntryValidation(field, logic, form, metaMap, vueData, fieldEventPrepend){
			if(logic.type === 'entryValidation' && logic.validationType) {
				/*
					NOTE:
						Embed the validation also on the field so it can prevent submit in addition to the realtime alert below
						IF YOU ARE TO USE THIS please add a validation to app.ui.requiredFieldsCheck
						- sg 07/10/2019
				*/
				(
					function(){
						$('#' + field.properties.id).attr('data-validation',logic.validationType);
					}
				).After(750);

				app.events.on(fieldEventPrepend + field.properties.id, function(event) {
					// Only execute Value Change logic after the UI has been initialized to avoid values changing on-load.
					if(event.type !== "ON_INIT") {
						var newValue = event.newValue;
						var validationToRun = {
							preventFutureDates : function(){
								var mom = moment(newValue);
								if(newValue.trim() !== '' && mom.isValid() && mom.isAfter(moment())){
									alert('You cannot enter a future date');
									$(field.container.parentElement).focus();
								}
							}
						}[logic.validationType];

						if(typeof validationToRun === 'function'){
							validationToRun();
						}
					}
				});
			}

			return self;
		}

		/*
			Name: fieldLevel
			Use: API.fieldLevel()
			Args: field ui.field - The UI field with all it's attributes to apply logic towards
			Description: Applies logic to a given field based upon it's logic attribute
		*/
		self.fieldLevel = function(field, form, vueData, fieldEventPrepend){
			var metaMap = {};
			form.forEach(
				function(itm,idx){
					if (itm) metaMap[itm.properties.id || new Date().getTime().toString()] = idx;
				}
			);

			if(!field.args.properties && field.properties){
				field.args.properties = field.properties;
			}

			field.args.logic.forEach(
				function(logic){
					/*
						NOTE:
							There's a weird and random bug where the show/hide doesn't fire appropriately if there's not a small timeout applied to the logic methods, hence why they all have a After(100) applied
							- sg 06/10/2019 HSC-752
					*/
					var timeout = 100;

					/*
						NOTE:
							filterBy allows for either another field or a predefined static value to be passed to the database to limit drop down options
							- sg 03/15/2016 WD-64
					*/
					if(logic.type === "filterBy"){
						applyFilter.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}
					/*
						NOTE:
							require action makes a field required when a certain value gets triggered
					*/
					else if(logic.type === "require"){
						applyRequire.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}
					/*
						NOTE:
							show/hide actions toggles a field's visibility when a certain value gets triggered
					*/
					else if(logic.type === "show" || logic.type === "hide"){
						applyVisibility.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}
					else if(logic.type === "change") {
						applyValueChange.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}
					/*
						NOTE:
							A quick implementation of validationes that are more static in nature.  For now, the first and only supported one is do not allow future dates
							- sg 07/10/2019
					*/
					else if(logic.type === 'entryValidation'){
						applyEntryValidation.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}

					else if(logic.type === 'constrainByOtherField'){
						constrainByOtherFieldSetup.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}
					else if(logic.type === 'populateOtherFields'){
						applyPopulateOtherFields.After(timeout,[field,logic, form, metaMap, vueData, fieldEventPrepend]);
					}
				}
			);

			return self;
		};

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: Initializes the component
		*/
		self.init = function(){
			return self;
		};

	}
);
